import { setPlaceByRegion } from '@app/store/actions/profile'
import { availableRegionsSlugsSelector, defaultRegionSelector } from '@app/store/selectors/regions'
import { regionsMapSelector } from '@app/store/slices/regions'
import { createThunk } from '@app/store/thunk'

import { matchRegion } from './region'

export const setPlaceByRegionSlug = (slug: string) =>
  createThunk(async (dispatch, getState) => {
    const state = getState()
    const regionsList = availableRegionsSlugsSelector(state)
    const defaultRegion = defaultRegionSelector(state)
    const matchedSlug = matchRegion(regionsList, slug)
    const region = !matchedSlug ? defaultRegion : Object.values(regionsMapSelector(getState())).find(r => r.attributes.slug === matchedSlug)
    if (!region) throw new Error(`Can't find region: ${region}`)

    return dispatch(setPlaceByRegion(region.id))
  })
